import { render, staticRenderFns } from "./failTransaction.vue?vue&type=template&id=d96fe3b8&scoped=true&"
var script = {}
import style0 from "./failTransaction.vue?vue&type=style&index=0&id=d96fe3b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96fe3b8",
  null
  
)

export default component.exports